import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { BaseForm } from 'components/common/forms/BaseForm/BaseForm';
import { useAppDispatch } from 'hooks/reduxHooks';
import { doResetPassword } from 'store/slices/authSlice';
import notificationHook from 'hooks/notificationHook';
import { authPaths } from 'constants/routePaths';
import { ApiError } from 'types';
import statusMessages from 'statusMessages';
import { Button, Col, Row } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Input } from 'components/common/inputs/Input/Input';
import 'styles/sass/auth-layout.scss';
import {
  EMAIL_VALIDATION_MESSAGE,
  normalizeEmailInput,
  validateAsciiEmail,
} from 'utils/emailPolicy';

interface ForgotPasswordFormData {
  email: string;
}

const initValues = {
  email: '',
};

export const ForgotPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = (values: ForgotPasswordFormData) => {
    setLoading(true);
    dispatch(
      doResetPassword({ ...values, email: normalizeEmailInput(values.email) })
    )
      .unwrap()
      .then(() => {
        navigate(`${authPaths.basePath}/${authPaths.login}`);
      })
      .catch((error) => {
        const currentStatus = (error as ApiError).statusCode;
        notificationHook({
          type: 'error',
          message: statusMessages.user[
            currentStatus ? currentStatus : 500
          ] as string,
        });
        setLoading(false);
      });
  };

  return (
    <div className="form-wrapper">
      <BaseForm
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark="optional"
        initialValues={initValues}
      >
        <Button className="back" onClick={() => navigate(-1)}>
          <LeftOutlined /> Regresar
        </Button>
        <h1 className="title">Recuperar contraseña</h1>
        <p className="my-5 mb-7">
          Ingresa tu dirección de email, te enviaremos instrucciones para
          ingresar una nueva contraseña
        </p>
        <BaseForm.Item
          className="form-item"
          name="email"
          label={`Email`}
          normalize={normalizeEmailInput}
          rules={[
            { required: true, message: EMAIL_VALIDATION_MESSAGE },
            { validator: validateAsciiEmail },
          ]}
        >
          <Input className="form-input" placeholder={`email`} />
        </BaseForm.Item>
        <Row justify="center" className="mt-5">
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              className="submit-btn"
            >
              Enviar correo
            </Button>
          </Col>
        </Row>
      </BaseForm>
    </div>
  );
};
